const data = {
  info: [
    {
      ct: 6001423200, coordinates: [37.8645164, -122.2936857], hbp: 89.7, cespr: '80-85%', color: '#E2565F', ZIP: 94710, pbp: 73.02,
    },
    {
      ct: 6001422000, coordinates: [37.8590327, -122.3013426], hbp: 50.05, cespr: '70-75%', color: '#F28147', ZIP: 94710, pbp: 93.68,
    },
    {
      ct: 6001424002, coordinates: [37.8504976, -122.2815989], hbp: 39.2, cespr: '65-70%', color: '#F28147', ZIP: 94702, pbp: 69.1,
    },
    {
      ct: 6001423300, coordinates: [37.8573287, -122.2842021], hbp: 73.93, cespr: '65-70%', color: '#E2565F', ZIP: 94702, pbp: 73.55,
    },
    {
      ct: 6001423100, coordinates: [37.865807, -122.2863197], hbp: 70.33, cespr: '60-65%', color: '#E2565F', ZIP: 94702, pbp: 66.46,
    },
    {
      ct: 6001422100, coordinates: [37.8733005, -122.2965391], hbp: 44.76, cespr: '55-60%', color: '#F28147', ZIP: 94710, pbp: 70.52,
    },
    {
      ct: 6001422200, coordinates: [37.8728822, -122.2878154], hbp: 67.52, cespr: '50-55%', color: '#E2565F', ZIP: 94702, pbp: 54.03,
    },
    {
      ct: 6001420400, coordinates: [37.8886213, -122.3256618], hbp: 98.72, cespr: '45-50%', color: '#E2565F', ZIP: 94710, pbp: 81.26,
    },
    {
      ct: 6001424001, coordinates: [37.8503526, -122.2746683], hbp: 84.18, cespr: '45-50%', color: '#E2565F', ZIP: 94703, pbp: 58.18,
    },
    {
      ct: 6001423000, coordinates: [37.8668441, -122.2771352], hbp: 73.27, cespr: '40-45%', color: '#E2565F', ZIP: 94703, pbp: 38.22,
    },
    {
      ct: 6001423400, coordinates: [37.8583737, -122.275884], hbp: 33.24, cespr: '35-40%', color: '#F28147', ZIP: 94703, pbp: 40.3,
    },
    {
      ct: 6001422900, coordinates: [37.8678899, -122.269247], hbp: 99.53, cespr: '30-35%', color: '#E2565F', ZIP: 94704, pbp: 16.27,
    },
    {
      ct: 6001423901, coordinates: [37.8523001, -122.2675177], hbp: 63.33, cespr: '30-35%', color: '#F28147', ZIP: 94703, pbp: 39.24,
    },
    {
      ct: 6001422700, coordinates: [37.8679125, -122.2495401], hbp: 98.79, cespr: '25-30%', color: '#E2565F', ZIP: 94704, pbp: 19.18,
    },
    {
      ct: 6001421900, coordinates: [37.8794799, -122.2896443], hbp: 5.11, cespr: '25-30%', color: '#008002', ZIP: 94702, pbp: 54.59,
    },
    {
      ct: 6001422800, coordinates: [37.8667875, -122.259979], hbp: 99.67, cespr: '25-30%', color: '#E2565F', ZIP: 94704, pbp: 30.67,
    },
    {
      ct: 6001422300, coordinates: [37.8740723, -122.2779152], hbp: 75.42, cespr: '25-30%', color: '#E2565F', ZIP: 94703, pbp: 26.75,
    },
    {
      ct: 6001423500, coordinates: [37.859365, -122.2680467], hbp: 78.13, cespr: '25-30%', color: '#E2565F', ZIP: 94703, pbp: 25.05,
    },
    {
      ct: 6001423602, coordinates: [37.8631882, -122.2592723], hbp: 99.39, cespr: '20-25%', color: '#E2565F', ZIP: 94704, pbp: 21.38,
    },
    {
      ct: 6001422500, coordinates: [37.8773131, -122.2603183], hbp: 85.62, cespr: '20-25%', color: '#E2565F', ZIP: 94709, pbp: 27.17,
    },
    {
      ct: 6001422400, coordinates: [37.8752396, -122.2695878], hbp: 91.31, cespr: '20-25%', color: '#E2565F', ZIP: 94709, pbp: 28.44,
    },
    {
      ct: 6001423902, coordinates: [37.8547152, -122.2573724], hbp: 41.03, cespr: '15-20%', color: '#F28147', ZIP: 94705, pbp: 19.49,
    },
    {
      ct: 6001423601, coordinates: [37.8588968, -122.2587175], hbp: 57.15, cespr: '10-15%', color: '#F28147', ZIP: 94705, pbp: 22.43,
    },
    {
      ct: 6001421800, coordinates: [37.8802854, -122.2782006], hbp: 17.04, cespr: '5-10%', color: '#008002', ZIP: 94703, pbp: 10.93,
    },
    {
      ct: 6001421700, coordinates: [37.8819398, -122.2701843], hbp: 42.68, cespr: '5-10%', color: '#F28147', ZIP: 94709, pbp: 14.11,
    },
    {
      ct: 6001423700, coordinates: [37.8618413, -122.248923], hbp: 64.67, cespr: '5-10%', color: '#F28147', ZIP: 94705, pbp: 17.25,
    },
    {
      ct: 6001421400, coordinates: [37.8883409, -122.270922], hbp: 15.72, cespr: '5-10%', color: '#008002', ZIP: 94707, pbp: 4.39,
    },
    {
      ct: 6001423800, coordinates: [37.8547587, -122.2441385], hbp: 19.19, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94705, pbp: 18.2,
    },
    {
      ct: 6013391000, coordinates: [37.90719, -122.284319], hbp: 21.34, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94707, pbp: 15.78,
    },
    {
      ct: 6001400100, coordinates: [37.8675947, -122.2319033], hbp: 12.91, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94704, pbp: 32.27,
    },
    {
      ct: 6001421200, coordinates: [37.8975481, -122.2752271], hbp: 7.39, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94707, pbp: 8.94,
    },
    {
      ct: 6001421500, coordinates: [37.8920346, -122.2590314], hbp: 2.34, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94708, pbp: 1.36,
    },
    {
      ct: 6001421300, coordinates: [37.8911093, -122.2813663], hbp: 8.3, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94707, pbp: 18.9,
    },
    {
      ct: 6001421100, coordinates: [37.899434, -122.2661928], hbp: 7.73, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94708, pbp: 2.66,
    },
    {
      ct: 6013392000, coordinates: [37.9094178, -122.2748794], hbp: 15.28, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94708, pbp: 5.92,
    },
    {
      ct: 6001421600, coordinates: [37.8839567, -122.2559829], hbp: 12.91, cespr: '1-5% (lowest scores)', color: '#008002', ZIP: 94708, pbp: 15.66,
    },
  ],
  minLat: 37.8503526,
  maxLat: 37.899434,
  minLong: -122.3256618,
  maxLong: -122.2319033,
};

export default data;
